export default __webpack_public_path__ + "static/02-838f96256b1863e00e28519b711831b1.jpg";